import Design1 from './design-1';
import {useEffect, useState} from "react";
import axios from "axios";
import {Loader} from "@autocx/forms";
import Spinner from "../../components/spinner";

ConfirmationBlock.propTypes = {};

ConfirmationBlock.defaultProps = {};

export default function ConfirmationBlock(props) {
    const [order, setOrder] = useState({});
    const [loading, setIsLoading] = useState(true);
    const [showLoader, setShowLoader] = useState(false)
    const [profile, setProfile] = useState(null)

    useEffect(() => {
        if(props.values.uuid === '' || props.values.uuid === undefined) return;
        
        let timer = setTimeout(() => {
            setShowLoader(true);
        }, 400);
        let active = true;
        
        axios.get('/api/v2/order/' + props.values.uuid)
            .then((response) => {
                if (!active) return;
                setOrder(response.data);
                // This endpoint requires an authenticated owner. A guest summary
                // must never be treated as permission to read saved details.
                if (response.data.id) {
                    axios.get(`/api/v2/orders/${response.data.id}/products?includePurchaseDetails=true`)
                        .then(({data}) => {
                            if (!active || !Array.isArray(data)) return;
                            const details = new Map(data.map(line => [line.id, line.purchaseDetails]));
                            setOrder(current => ({...current, products: current.products?.map(line =>
                                ({...line, purchaseDetails: details.get(line.id)}))}));
                        })
                        .catch(() => { /* Guest and old orders keep their existing summary. */ });
                }
            })
            .then(() => {
                axios.get('/api/v2/publicusers/profile/')
                    .then(({data}) => {
                        setProfile(data)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
            .finally(() => {
                setIsLoading(false); 
                setShowLoader(false)
                clearTimeout(timer);
            });

        return () => { active = false; clearTimeout(timer); };

    }, [props.values.uuid]);

    if (loading) {
        if (showLoader) {
            return <Spinner containerClassName={"h-[50vh]"}/>;
        }
        return null; 
    }
    
    switch (props.settings?.design) {
        case 0 :
            return (<Design1 {...props} order={order} profile={profile}/>);
        default:
            return (<Design1 {...props} order={order} profile={profile}/>);
    }
    
};
